import React from 'react';
import { useNotification } from '../context/NotificationContext';

const Toast = () => {
  const { notifications, removeNotification } = useNotification();

  return (
    <div style={{ position: 'fixed', top: 20, right: 20, zIndex: 9999, maxWidth: 400 }}>
      {notifications.map(notif => (
        <div
          key={notif.id}
          style={{
            marginBottom: 10,
            padding: 12,
            borderRadius: 4,
            background: notif.type === 'success' ? '#d4edda' : notif.type === 'error' ? '#f8d7da' : '#d1ecf1',
            color: notif.type === 'success' ? '#155724' : notif.type === 'error' ? '#721c24' : '#0c5460',
            border: `1px solid ${notif.type === 'success' ? '#c3e6cb' : notif.type === 'error' ? '#f5c6cb' : '#bee5eb'}`,
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <span>{notif.message}</span>
          <button
            onClick={() => removeNotification(notif.id)}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: 18,
              marginLeft: 12,
              opacity: 0.7,
            }}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default Toast;
